export default __webpack_public_path__ + "static/media/masters-reviews.e02dade8.PNG";